import { render, staticRenderFns } from "./SiretNumberComponent.vue?vue&type=template&id=2cb8e796&scoped=true"
import script from "./SiretNumberComponent.vue?vue&type=script&lang=js"
export * from "./SiretNumberComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb8e796",
  null
  
)

export default component.exports